import { useTranslation } from 'react-i18next';

interface CTABannerSectionProps {
  onRegisterClick: () => void;
}

const CTABannerSection = ({ onRegisterClick }: CTABannerSectionProps) => {
  const { t } = useTranslation('choHem');

  return (
    <section className="py-14 md:py-20 relative overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            'url(https://public.readdy.ai/ai/img_res/18327b74fc507dfb7d18e49974fa2aef.jpg)',
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/70 to-black/85"></div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-white font-serif mb-4 leading-tight">
          {t('ctaBanner.title')}
        </h2>
        <p className="text-gray-300 text-sm md:text-lg mb-3 max-w-2xl mx-auto">
          {t('ctaBanner.subtitle')}
        </p>
        <p className="text-amber-400 font-bold text-base md:text-xl mb-8">
          {t('ctaBanner.price')}
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            onClick={onRegisterClick}
            className="px-8 py-3.5 bg-amber-500 text-black font-bold rounded-lg hover:bg-amber-400 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer text-sm md:text-base"
          >
            {t('ctaBanner.cta')}
          </button>
          <a
            href="tel:+37125726969"
            className="px-8 py-3.5 bg-white/10 text-white font-semibold rounded-lg hover:bg-white/20 border border-white/30 transition-all whitespace-nowrap cursor-pointer text-sm md:text-base flex items-center justify-center gap-2"
          >
            <i className="ri-phone-line"></i>
            {t('ctaBanner.phone')}
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTABannerSection;